module.exports = __webpack_public_path__ + "static/media/og03.614ff7d3.webp";